/* esm.sh - @radix-ui/react-use-is-hydrated@0.1.0 */
export * from "/*@radix-ui/react-use-is-hydrated@0.1.0/esnext/react-use-is-hydrated.mjs";
